import { OfferApiFormEditForm } from "components/Forms/OfferApiFormEditForm/OfferApiFormEditForm.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useUser } from "hooks/useUser.ts";
import { ConversionStateInput, PermissionEnum, RoleEnum } from "types/enums.ts";
import { FormId } from "types/models.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getOfferEditHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/api/"
)({
    component: OfferApiEditPage,
    staticData: {
        permissions: [PermissionEnum.OfferEditApi],
        showInSideMenu: false,
        label: "pages.offer.edit.api.title",
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.offer.edit.api.title"),
    }),
});

function OfferApiEditPage() {
    const { offerId } = Route.useParams();
    const userUtils = useUser();
    const { t } = usePaldockTranslation("pages.offer.edit");

    return (
        <TenantPage
            headerNavigationItems={getOfferEditHeaderItems}
            saveFormId={FormId.OfferApiFormEditForm}
            isEdit={true}
            detailLink={
                userUtils
                    ?.getActiveTenant()
                    ?.userRoles?.some((role) => [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name))
                    ? {
                          to: "/offer/detail/$offerId/api",
                          params: { offerId: offerId },
                          label: t("offer_preview"),
                      }
                    : null
            }
        >
            <OfferApiFormEditForm key={offerId} offerId={offerId} conversionStateInput={ConversionStateInput.API} />
        </TenantPage>
    );
}
